function TransAnchor({ pagelink, pagestring }) {
  return (
    <a aria-current="page" href={pagelink}>
      {pagestring}
    </a>
  );
}

export default TransAnchor;
